import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { contact } from 'contact/model/contact.fragments';
import { jobOffer } from 'job/model/job-offer.fragments';
import { tasksParticipant } from 'task/model/task.fragments';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { TaskOutput } from '../model/task.output';

export interface UpdateTaskInput {
	readonly taskId: string;
	readonly taskDueTimestamp: number;
}

export interface UpdateTaskParams {
	input: UpdateTaskInput;
}

@Injectable({ providedIn: 'root' })
export class UpdateTaskApiMutation extends ApiMutation<
	TaskOutput,
	UpdateTaskParams
> {
	client = 'iam';
	document = gql`
		mutation UpdateTask($input: UpdateTaskInput!) {
			updateTask(input: $input) {
				id
				done
				type
				owner {
					id
				}
				contact {
					...Contact
				}
				jobOffer {
					...JobOffer
				}
				modulesId
				todoTitle
				dueTimestamp
				updateTimestamp
				participants {
					...TasksParticipant
				}
				todoDescription
			}
		}
		${tasksParticipant}
		${jobOffer}
		${contact}
	`;
	method = 'updateTask';
}
